import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function CheckProfile() {
  const navigate = useNavigate();

  useEffect(() => {
    const check = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('https://nagradjivanje-api.revicon.info/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data.completed) {
          navigate('/questionnaire/1');
        } else {
          navigate('/profile/edit');
        }
      } catch (err) {
        alert('Greška prilikom provjere profila.');
        navigate('/login');
      }
    };
    check();
  }, [navigate]);

  return <p className="text-center mt-10">Provjera profila...</p>;
}
